<template>
  <div class="cp-ShoppingList_Overlay">
    <button
      v-if="isActive"
      type="button"
      class="btn btn-outline-danger cp-ShoppingList_Button"
      @click="decrease"
    >
      <i class="fa fa-minus"></i>
    </button>
    <div
      v-if="isActive"
      class="h6 mb-0 cp-ShoppingList_Amount p-1"
      :class="{ 'cp-ShoppingList_Amount-active': isActive }"
    >
      {{ quantity }}
    </div>
    <button
      type="button"
      class="btn btn-outline-success cp-ShoppingList_Button"
      :disabled="!increasable"
      @click="increase"
    >
      <i class="fa fa-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    quantity: {
      type: Number,
      default: 0,
    },
    increasable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isActive() {
      return this.quantity > 0;
    },
  },
  methods: {
    increase() {
      this.$emit("increase");
    },
    decrease() {
      this.$emit("decrease");
    },
  },
};
</script>
